<script lang="ts" module>
  import type { HTMLAttributes } from 'svelte/elements';
  import type { Snippet } from 'svelte';

  export namespace AssistantPanel {
    export interface Props extends HTMLAttributes<HTMLDivElement> {
      children?: Snippet;
    }
  }
</script>

<script lang="ts">
  let { children, ...props }: AssistantPanel.Props = $props();
</script>

<div
  {...props}
  class="mt-[-10px] grid w-full gap-2 overflow-hidden rounded-b-md bg-prim px-3 pb-3 pt-6 shadow-card"
>
  {@render children?.()}
</div>
